// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { Cart } from "@insite/client-framework/Services/CartService";
import { BillToModel } from "@insite/client-framework/Types/ApiModels";

export const isReleaseNumberRequired = (billTo?: BillToModel) => {
    return billTo?.properties["poReleaseRequired"] === "R" || billTo?.properties["poReleaseRequired"] === "B";
};

export const isPORequired = (billTo?: BillToModel) => {
    return (
        billTo?.properties["poReleaseRequired"] === "P" ||
        billTo?.properties["poReleaseRequired"] === "B" ||
        billTo?.isGuest
    );
};

export const isCartNotesRequired = (cart?: Cart) => {
    if (cart && cart.shipVia && cart.shipVia.description) {
        return (
            cart.shipVia.description.toLowerCase() === "use my fedex acct #" ||
            cart.shipVia.description.toLowerCase() === "use my ups acct #"
        );
    }
    return false;
};
